import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy, faEdit, faLocationPin} from "@fortawesome/free-solid-svg-icons";
import {useState} from "react";
import {DatePicker} from "zaman";
import {faNumberToEn} from "../../../helper/general";
import moment from "jalali-moment";
import Toman from "../../Utilities/Toman";
import Modal from "../../Utilities/Modal";
import CustomerAddressList from "../../Customer/CustomerAddressList";
import ApiRoute from "../../../helper/api";
import {HasAccessComponent} from "../../../helper/permissions";

export default function OrderCustomerInfo({order, setUpdateState}){
    const [modal, setModal] = useState(null);
    const [selectedAddress , setSelectedAddress] = useState(order?.address)
    const address = order.address

    async function handleSubmit(){
        const res = await ApiRoute.order.shipment.updateAddress.fn(order._id,selectedAddress.id,{
            address : selectedAddress,
            customer_id: order.customer_id
        })
        if(res?.status_code === 200){
            setUpdateState(Date.now())
            setModal(false)
        }
    }

    async function copyToClipboard(value) {
        await navigator.clipboard.writeText(String(value));
    }

    return (
        <div>
            <div
                className="main-content before-table-style before-purple border border-gray-7 relative rounded-md p-5 mt-4">
                <div className="page-title mb-3">
                                <span className="inline-block bg-white pl-3 text-sm">
                                    اطلاعات گیرنده
                                <FontAwesomeIcon className="mr-2 text-green-1" icon={faLocationPin}/>
                                </span>
                </div>
                <div
                    className="grid sm:grid-cols-2 xl:flex justify-between gap-3 lg:gap-5 text-xs mt-5">
                    <div>
                        <span className="text-gray-2">نام گیرنده:</span>
                        <span className="text-gray-5 mr-1">{address.first_name+" "+address.last_name}</span>
                    </div>

                    <div>
                        <span className="text-gray-2">استان:</span>
                        <span className="text-gray-5 mr-1">{address.coordinates.state.faname}</span>
                    </div>

                    <div>
                        <span className="text-gray-2">شهر:</span>
                        <span className="text-gray-5 mr-1">{address.coordinates.city.faname}</span>
                    </div>

                    <div>
                        <span className="text-gray-2">محله:</span>
                        <span className="text-gray-5 mr-1">{address.coordinates?.area?.faname}</span>
                    </div>

                    <div>
                        <span className="text-gray-2">شماره تماس گیرنده:</span>
                        <span className="text-gray-5 mr-1">{address.cellphone}</span>
                    </div>

                    <div>
                        <span className="text-gray-2">کد پستی:</span>
                        <span className="text-gray-5 mr-1">{address.address.postcode}</span>
                    </div>
                </div>
                <div
                    className="grid sm:grid-cols-2 xl:flex justify-between gap-3 lg:gap-5 text-xs mt-5">
                    <div>
                        <span className="text-gray-2">آدرس:</span>
                        <span className="text-gray-5 mr-1">{address.address.address}</span>
                    </div>

                    <div>
                        <span className="text-gray-2">نام ساختمان:</span>
                        <span className="text-gray-5 mr-1">{address.address.house_name}</span>
                    </div>

                    <div>
                        <span className="text-gray-2">پلاک:</span>
                        <span className="text-gray-5 mr-1">{address.address.house_number}</span>
                    </div>

                    <div>
                        <span className="text-gray-2">طبقه:</span>
                        <span className="text-gray-5 mr-1">{address.address.floor}</span>
                    </div>

                    <div>
                        <span className="text-gray-2">واحد:</span>
                        <span className="text-gray-5 mr-1">{address.address.unit}</span>
                    </div>

                     {address?.coordinates?.lat && (
                                <div>
                                    <span className="text-gray-2">مختصات: </span>
                                    <div className="text-gray-5 text-left">
                                        <p>
                                            lat: {address?.coordinates?.lat}
                                            <button
                                                type="button"
                                                className="mr-1"
                                                title="Copy latitude"
                                                aria-label="Copy latitude"
                                                onClick={() => copyToClipboard(address.coordinates.lat)}
                                            >
                                                <FontAwesomeIcon icon={faCopy}/>
                                            </button>
                                        </p>
                                        <p>
                                            lng: {address?.coordinates?.lng}
                                            <button
                                                type="button"
                                                className="mr-1"
                                                title="Copy longitude"
                                                aria-label="Copy longitude"
                                                onClick={() => copyToClipboard(address.coordinates.lng)}
                                            >
                                                <FontAwesomeIcon icon={faCopy}/>
                                            </button>
                                        </p>
                                    </div>
                                </div>
                            )}

                    
                </div>
                <div
                    className="grid lg:flex justify-between items-center lg:grid-cols-2 gap-3 lg:gap-5 text-xs mt-5">
                    <div>
                        <span className="text-gray-2">ملاحظات آدرس (یادداشت مشتری):</span>
                        <span className="text-purple-1 mr-1">{order?.metadata?.note}</span>
                    </div>

                        { !['completed', 'shipment'].includes(order?.status) && <div className="max-lg:text-left">
                            <button onClick={() => {
                                setModal(true)
                            }} className="btn-outline-gray">تغییر نشانی گیرنده</button>
                        </div>}
                    
                </div>
            </div>

            <Modal isOpen={modal} onClose={() => {
                setModal(false)
            }}>
                <div className="page-title mb-5"><span
                    className="inline-block bg-white pl-3 text-sm text-purple-1">تغییر آدرس</span>
                </div>
                <div className="form">
                    <CustomerAddressList setSelected={ (x) => {
                        setSelectedAddress(x)
                    } } selectAble={true} selected={selectedAddress} customClass={`main-content !shadow-none mx-auto p-0 mt-12`} customer={order.customer}/>

                    <button onClick={handleSubmit} className={`btn-green mt-3 py-1 text-13 rounded`}>بروزرسانی</button>

                </div>
            </Modal>

        </div>
    )
}
